module.exports = __webpack_public_path__ + "05b8c0f623edc7f03cf92c095061b13a.pdf";